module.exports = __webpack_public_path__ + "static/media/btn_bird.043feb57.png";